export const CANCEL_CURRENT_PURCHASE = 'CANCEL_CURRENT_PURCHASE';
export const GET_AVAILABLE_OPTIONS_FOR_ORDER =
  'GET_AVAILABLE_OPTIONS_FOR_ORDER';
export const GET_CASE_DEFAULTS = 'GET_CASE_DEFAULTS';
export const GET_DASHBOARD = 'GET_DASHBOARD';
export const GET_DASHBOARD_NO_LOADING_INDICATOR =
  'GET_DASHBOARD_NO_LOADING_INDICATOR';
export const PAUSE_LOCK_TIMER = 'PAUSE_LOCK_TIMER';
export const START_PURCHASE_WITH_VEHICLE_ID = 'START_PURCHASE_WITH_VEHICLE_ID';
export const SWITCH_VEHICLE = 'SWITCH_VEHICLE';
export const UPDATE_DASHBOARD_COMPLETE = 'UPDATE_DASHBOARD_COMPLETE';

const ACTION_PREPEND = 'purchase';
export const ORDER_SUMMARY_FETCH = `${ACTION_PREPEND}/ORDER_SUMMARY_FETCH`;
export const GET_OPD_NOTIFICATIONS = `${ACTION_PREPEND}/GET_OPD_NOTIFICATIONS`;
export const GET_PAYMENT_SUMMARY = `${ACTION_PREPEND}/GET_PAYMENT_SUMMARY`;
